<template>
    <div class="page" v-loading="loading">
        <el-form :model="form" label-width="100px" ref="form">
            <el-row>
                <el-col :span="6">
                    <el-form-item label="订单类型" prop="Status">
                        <el-select v-model="form.Status" placeholder="请选择" style="width:100%">
                            <el-option v-for="(item, index) in status" :label="item.label" :value="item.value"
                                :key="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="子订单号" prop="OrderNo">
                        <el-input v-model="form.OrderNo" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="商品名称" prop="ProductSkuName">
                        <el-input v-model="form.ProductSkuName" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="收货人姓名" prop="ReceivingName">
                        <el-input v-model="form.ReceivingName" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="收货人电话" prop="ReceivingMobile">
                        <el-input v-model="form.ReceivingMobile" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="供应商" prop="SupplierId">
                        <el-select v-model="form.SupplierId" filterable remote placeholder="请选择 / 可搜索"
                            :remote-method="querySupplier" style="width:100%">
                            <el-option v-for="item in supplier" :key="item.id" :label="item.proSupplierName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="下单时间">
                        <el-date-picker v-model="datePicker" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker"
                            class="w100">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="外部订单号" prop="OutOrderNo">
                        <el-input v-model="form.OutOrderNo" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item>
                        <div class="flex">
                            <el-button type="primary" @click="getData">查询</el-button>
                            <el-button @click="resetForm">重置</el-button>
                            <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction">
                            </toolbar>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <ul class="ul">
            <li v-for="(item, index)  in status" :key="index" v-if="item.class">
                <div :class="item.class"></div>
                <p>{{ item.label }}</p>
            </li>
        </ul>
        <el-table border :data="tableData" style="width: 100%" :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }" :row-class-name="tableRowClassName" :span-method="arraySpanMethod">
            <el-table-column prop="code" label="子订单号" width="280">
                <template slot-scope="scope">
                    <div>{{ scope.row.orderNo }}</div>
                    <el-tag size="mini" v-if="scope.row.platformType === 1 && scope.row.platformOrder" type="danger">
                        京东订单：{{ scope.row.receivingName }} / 已下单：{{ scope.row.platformOrder }}
                    </el-tag>
                  <p>
                    <el-tag size="mini" v-if="scope.row.isHaveAfterOrder && scope.row.outOrderNo" effect="dark" type="danger">外部订单有售后订单</el-tag>
                  </p>
                </template>
            </el-table-column>
            <el-table-column prop="resellerName" label="订单来源" width="120"></el-table-column>
            <el-table-column prop="name" label="订单状态" width="150">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 1">待采购订单</span>
                    <span v-if="scope.row.status == 2">待发货订单</span>
                    <span v-if="scope.row.status == 3">待收货订单</span>
                    <span v-if="scope.row.status == 4">已发货订单</span>
                </template>
            </el-table-column>
            <el-table-column prop="outOrderNo" label="外部订单号" width="200"></el-table-column>
            <el-table-column label="商品信息" width="250">
                <template slot-scope="scope">
                    <span style="display: inline-block;margin-right:10px;">{{
                            scope.row.orderItems && scope.row.orderItems[0] &&
                            scope.row.orderItems[0].productSkuName
                    }}</span>
                </template>
            </el-table-column>
            <el-table-column label="商品规格" align="center" width="120">
                <template slot-scope="scope">
                <span style="display: inline-block;margin-right:10px;">{{
                    scope.row.orderItems && scope.row.orderItems[0] &&
                    scope.row.orderItems[0].productSpecExt ? scope.row.orderItems[0].productSpecExt : scope.row.orderItems[0].productSpec
                }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="payTotalAccount" label="实付金额" width="150"></el-table-column>
            <el-table-column prop="lastModificationTime" label="收货信息" width="280">
                <template slot-scope="scope">
                    {{ scope.row.receivingName }} /
                    {{ scope.row.receivingMobile }}
                    <br />
                    {{ scope.row.receivingProviceName }} /
                    {{ scope.row.receivingCityName }} /
                    {{ scope.row.receivingDistrictName }} /
                    {{ scope.row.receivingStreetName }}
                    <br />
                    {{ scope.row.receivingAddress }}
                </template>
            </el-table-column>
            <el-table-column label="采购供应商" width="200">
                <template slot-scope="scope">
                    <el-table border :data="scope.row.orderPurchases" style="width: 100%" :show-header="false"
                        :cell-style="{ 'text-align': 'center' }">
                        <el-table-column prop="productSupplierName" width="188">
                        </el-table-column>
                        <el-table-column prop="orderPurchaseNo" width="200">
                        </el-table-column>
                        <el-table-column width="200">
                            <template slot-scope="scope">
                                {{ scope.row.isShipped ? '已发货' : '未发货' }}
                            </template>
                        </el-table-column>
                        <el-table-column width="240">
                            <template slot-scope="scope" v-if="scope.row.orderLogistics.length">
                                <div
                                    @click="checkDeliveryDetail(item)" style="cursor:pointer;text-decoration:underline"
                                    v-for="(item, index) in scope.row.orderLogistics" :key="index">
                                    物流公司:{{ item.logisticsCompanyName }}
                                    <br>
                                    物流单号:{{ item.logisticsNo }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shipmentQuantity" width="190">
                        </el-table-column>
                        <el-table-column width="200">
                            <template slot-scope="scope">
                                {{ scope.row.purchaseQuantity - scope.row.shipmentQuantity }}
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </el-table-column>
            <el-table-column label="采购单号" width="200"></el-table-column>
            <el-table-column label="订单状态" width="200"></el-table-column>
            <el-table-column label="物流信息" width="240"></el-table-column>
            <el-table-column label="已发货数量" width="200"></el-table-column>
            <el-table-column label="剩余发货数量" width="200"></el-table-column>
        </el-table>
        <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="PageIndex" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="form.MaxResultCount"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>

        <el-dialog title="查询物流详情" :visible.sync="loggisDetailDialog" :show-close="false" :close-on-click-modal="false"
               width="40%">
          <div v-if="loggisDetailList.length">
            <div v-for="(item, i) in loggisDetailList" :key="i" style="margin-bottom:10px;padding-bottom:10px;border-bottom:1px dashed #eee">
              <p style="color:#999;font-size:12px;margin-bottom:5px;">{{item.time}}</p>
              <p style="color:#333;font-size:14px;">{{item.description}}</p> 
            </div>
          </div>
          <div v-if="loadLoggisDetailEnd&&!loggisDetailList.length" style="text-align:center;color:#999;font-size:14px;padding:30px 0;">暂无物流信息！</div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="loggisDetailDialog=false">关闭</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
import {
    OrderPurchaseGetAll,
    SupplierGetAll,
    OrderExport,
    GetOrderLogistics
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
export default {
    components: { Toolbar },
    data() {
        return {
            form: {
                Status: null,
                OrderNo: "",
                ProductSkuName: "",
                ReceivingName: "",
                ReceivingMobile: "",
                SupplierId: "",
                OutOrderNo: "",
                CreationStartTime: "",
                CreationEndTime: "",
                SkipCount: 0,
                MaxResultCount: 10
            },
            datePicker: [],
            PageIndex: 1, //页码
            supplier: [],
            status: [
                { value: null, label: '全部' },
                { value: 1, label: '待采购订单', class: "table-row-1" },
                { value: 2, label: '待发货订单', class: "table-row-2" },
                { value: 3, label: '待收货订单', class: "table-row-3" },
                { value: 4, label: '已发货订单', class: "table-row-4" },
            ],
            loading: false,
            tableData: [],
            total: 0,
            buttonList_toolBar: [],
            
            loggisDetailDialog: false,
            loggisDetailList: [],
            loadLoggisDetailEnd: false,
            logisDetailShow: false
        };
    },
    created() {
        this.queryData()
        this.querySupplier()
    },
    mounted() {
        let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        var buttonList = getButtonList(this.$route.path, routers);
        if (buttonList && buttonList.length > 0) {
          buttonList.forEach((item) => {
            if (item.buttonFunc === "logisDetail") {
              this.logisDetailShow = true;
            }
          })
          this.buttonList_toolBar = buttonList.filter((item) => {
              return item.buttonShow === 10;
          })
        }
    },
    methods: {
        checkDeliveryDetail(data) {
          if (!this.logisDetailShow) return 
          this.loggisDetailList = []
          this.loadLoggisDetailEnd = false
          this.loggisDetailDialog = true
          GetOrderLogistics({
            LogisticsCompanyCode: data.logisticsCompanyCode,
            LogisticsCode: data.logisticsNo
          }).then(res => {
            if (res.data.success) {
              this.loggisDetailList = res.data.result.data
            }
            this.loadLoggisDetailEnd = true
          })
        },
        queryData() {
            this.loading = true
            this.form.SkipCount = (this.PageIndex - 1) * this.form.MaxResultCount;
            OrderPurchaseGetAll(this.form).then(res => {
                if (res.data.success) {
                    this.tableData = res.data.result.items
                    this.total = res.data.result.totalCount
                }
                setTimeout(() => {
                    this.loading = false
                }, 500)
            })
        },
        querySupplier(value) {
            SupplierGetAll({
                SkipCount: 0,
                MaxResultCount: 100,
                supplierName: value
            }).then(res => {
                if (res.data.success) {
                    this.supplier = res.data.result.items
                }
            })
        },
        handleSizeChange(val) {
            this.form.MaxResultCount = val
            this.queryData()
        },
        handleCurrentChange(val) {
            this.PageIndex = val
            this.queryData()
        },
        getData() {
            this.PageIndex = 1
            this.queryData()
        },
        resetForm() {
            this.datePicker = []
            this.form.CreationStartTime = ""
            this.form.CreationEndTime = ""
            this.PageIndex = 1
            this.form.MaxResultCount = 10
            this.$refs["form"].resetFields();
            this.queryData()
        },
        handlePicker(val) {
            if (!val) {
                this.form.CreationStartTime = ""
                this.form.CreationEndTime = ""
            } else {
                this.form.CreationStartTime = val[0]
                this.form.CreationEndTime = val[1]
            }
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.status === 1) {
                return 'table-row-1';
            } else if (row.status === 2) {
                return 'table-row-2';
            } else if (row.status === 3) {
                return 'table-row-3';
            } else if (row.status === 4) {
                return 'table-row-4';
            }
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 8) {
                return [1, 6]
            }
            // if (rowIndex % 2 === 0) {
            //     if (columnIndex === 0) {
            //         return [1, 2];
            //     } else if (columnIndex === 1) {
            //         return [0, 0];
            //     }
            // }
        },
        callFunction(item) {
            this[item.buttonFunc](this, item);
        },
        handleExport() {
            this.form.SkipCount = (this.PageIndex - 1) * this.form.MaxResultCount;
            OrderExport(this.form).then(res => {
                let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
                let objectUrl = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.download = '订单列表数据.xlsx'
                a.href = objectUrl
                a.click()
                a.remove()
            })
        }
    }
};
</script>
<style scoped>
.box-card {
    margin: 0 20px;
}

.table-row-1 {
    background: oldlace;
}

.table-row-2 {
    background: #f0f9eb;
}

.table-row-3 {
    background: #eaeefb;
}

.table-row-4 {
    background: #f8e2e2;
}

.el-table>>>.table-row-1 {
    background: oldlace;
}

.el-table>>>.table-row-2 {
    background: #f0f9eb;
}

.el-table>>>.table-row-3 {
    background: #eaeefb;
}

.el-table>>>.table-row-4 {
    background: #f8e2e2;
}

.ul {
    display: flex;
}

.ul li {
    display: flex;
    align-items: center;
    margin-right: 10px;
    font-size: 14px;
    color: #606266;
}

.ul li div {
    width: 14px;
    height: 14px;
}

.ul li p {
    margin-left: 5px;
}

.el-table {
    margin-top: 10px;
}
</style>
